module.exports = __webpack_public_path__ + "img/credit-cards-448.4383f456.png";